window.o_global = window.o_global || {};
window.o_util = window.o_util || {};

/**
 * Utility collection of event handling methods.
 *
 * @return {Object} Public methods of o_util.event.
 */
o_util.event = (function() {
    "use strict";

    /**
     * @deprecated Use native element.addEventListener instead.
     *
     * Add an event listener to a given DOM element.
     *
     * Older browsers do not support the event.target property.
     * To get the target use: o_util.event.getTarget(event)
     *
     * @example o_util.event.add(domElement, "click", eventHandler);
     *
     * @param {Object} obj              The DOM element the eventListener will be added to.
     * @param {String} type             The name of the event to bind a listener for.
     *                                  See https://developer.mozilla.org/en-US/docs/Web/Events for possible events.
     * @param {Function} fn             Event handler to attach to the event.
     * @param {Boolean} useCapture      If true, events of this type will be dispatched to the registered listener
     *                                  before being dispatched to any EventTarget beneath it in the DOM tree.
     */
    function add(obj, type, fn, useCapture) {
        o_global.debug.warn("o_util.event.add is deprecated, use native addEventListener instead");

        obj.addEventListener(type, fn, useCapture || false);
    }

    /**
     * @deprecated Use native element.removeEventListener instead.
     *
     * Remove a specific event listener from the element it was bound to.
     *
     * @example o_util.event.remove(domElement, "click", eventHandler);
     *
     * @param {Object} obj      The DOM element to remove the the listener from.
     * @param {String} type     Event type for which the handler will be removed.
     * @param {Function} fn     Event handler to be removed.
     */
    function remove(obj, type, fn) {
        o_global.debug.warn("o_util.event.remove is deprecated, use native removeEventListener instead");

        obj.removeEventListener(type, fn, false);
    }

    /**
     * Convenient helper to realize event delegation.
     * This function binds an event listener to a 'parent' element (delegationTarget). The given
     * event handler function will only be called if the eventTarget is one
     * of the determined possible targets (eventTargetSelector).
     *
     * @example
     * o_util.event.delegate(".myParent", "click", ".myChild", eventHandler);
     * o_util.event.delegate(document, "click", ".myChild", eventHandler);
     *
     * @param {String|Object} delegationTarget  Parent element in which possible event targets are encapsulated.
     * @param {String} eventName                Type of event, e.g. click, hover, mouseover.
     * @param {String} eventTargetSelector      Selector for permitted event targets.
     * @param {Function} fn                     Event handler to run when event occurs.
     * @param {Boolean} useCapture              If true, events of this type will be dispatched to the registered listener
     *                                          before being dispatched to any EventTarget beneath it in the DOM tree.
     */
    function delegate(delegationTarget, eventName, eventTargetSelector, fn, useCapture) {
        var element,
            possibleTargets,
            target,
            el,
            p;

        if (typeof delegationTarget === "object" && delegationTarget.addEventListener) {
            element = delegationTarget;
        } else {
            element = (delegationTarget === "document") ? document : document.querySelector(delegationTarget);
        }

        element.addEventListener(eventName, function(event) {
            possibleTargets = element.querySelectorAll(eventTargetSelector);
            target = event.target;

            for (var i = 0, l = possibleTargets.length; i < l; i++) {
                el = target;
                p = possibleTargets[i];

                while (el && el !== element) {
                    if (el === p) {
                        return fn.call(p, event);
                    }

                    el = el.parentNode;
                }
            }
        }, useCapture || false);
    }

    /**
     * @deprecated Use native event.target instead.
     *
     * Cross browser determination of the actual event target of a given event.
     *
     * @example o_util.event.getTarget(event);
     *
     * @param {Object} event    Emitted event object.
     *
     * @return {Object} Actual event target.
     */
    function getTarget(event) {
        o_global.debug.warn("o_util.event.getTarget is deprecated, use native event.target instead");

        return event.target;
    }

    /**
     * Convenience function to stop event propagation and
     * bubbling in one shot.
     *
     * @example o_util.event.stop(event);
     *
     * @param {Object} event    Event object to stop from propagating and bubbling.
     */
    function stop(event) {
        event.stopPropagation();
        event.preventDefault();
    }

    /**
     * @deprecated Use native event.stopPropagation instead.
     *
     * Helper function to stop event propagation for browsers and IE.
     *
     * @example o_util.event.stopPropagation(event);
     *
     * @param {Object} event    Event object
     */
    function stopPropagation(event) {
        o_global.debug.warn("o_util.event.stopPropagation is deprecated, use native event.stopPropagation instead");

        event.stopPropagation();
    }

    /**
     * @deprecated Use native event.stopPropagation instead.
     *
     * Helper function to handle preventDefault for browsers and IE.
     *
     * @example o_util.event.preventDefault(event);
     *
     * @param {Object} event    Event object
     */
    function preventDefault(event) {
        o_global.debug.warn("o_util.event.preventDefault is deprecated, use native event.preventDefault instead");

        event.preventDefault();
    }

    /**
     * Return the transitionend event that is actually supported by the used browser.
     *
     * @example var transitionEndEvent = o_util.event.whichTransitionEvent();
     *
     * @return {String} Transition event understood by browser.
     */
    function whichTransitionEndEvent() {
        var el = document.createElement("fakeelement"),
            transitions = {
                "WebkitTransition": "webkitTransitionEnd",
                "transition": "transitionend",
                "OTransition": "oTransitionEnd",
                "MozTransition": "transitionend"
            };

        for (var t in transitions) {
            if (transitions.hasOwnProperty(t)) {
                if (el.style[t] !== undefined) {
                    return transitions[t];
                }
            }
        }
    }

    /**
     * @deprecated Use native CustomElements instead. https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
     *
     * Trigger an HTMLEvent.
     *
     * @example
     * o_util.event.trigger(document.getElementById("el"), "click");
     *
     * @param {Object} element      The HTMLEvent will be fired on this HTMLElement.
     * @param {String} type         HTMLEvent type (click, change...)
     */
    function trigger(element, type) {
        o_global.debug.warn("o_util.event.trigger is deprecated, use native CustomElements instead");

        var event = document.createEvent("HTMLEvents");

        event.initEvent(type, true, true);
        element.dispatchEvent(event);
    }

    /**
     * Return public API.
     */
    return {
        "add": add,
        "remove": remove,
        "delegate": delegate,
        "getTarget": getTarget,
        "stop": stop,
        "stopPropagation": stopPropagation,
        "preventDefault": preventDefault,
        "whichTransitionEndEvent": whichTransitionEndEvent,
        "trigger": trigger
    };
}());

// Namespace fallbacks.
o_global.helper = o_global.helper || {};
o_global.helper.addEvent = o_util.event.add;
o_global.helper.delegate = o_util.event.delegate;
o_global.helper.getEventTarget = o_util.event.getTarget;
o_global.helper.preventDefault = o_util.event.preventDefault;
o_global.helper.removeEvent = o_util.event.remove;
o_global.helper.stopEvent = o_util.event.stop;
o_global.helper.stopPropagation = o_util.event.stopPropagation;
o_global.helper.whichTransitionEvent = o_util.event.whichTransitionEndEvent;
